// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields .field[data-v-04560c2a]{margin-top:0;margin-bottom:8px}.fields[data-v-04560c2a] label{font-size:.9em;padding:0 !important;padding-left:5px !important}`, "",{"version":3,"sources":["webpack://./components/modal/EditExif.vue"],"names":[],"mappings":"AAEE,gCACE,YAAA,CACA,iBAAA,CAEF,+BACE,cAAA,CACA,oBAAA,CACA,2BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
